// Hero scroll-down cue — smooth-scroll to the section right after the hero.
{
  document.querySelectorAll('.hero--scroll-cue').forEach(btn => {
    btn.addEventListener('click', () => {
      const hero = btn.closest('.hero')
      const target = hero?.nextElementSibling
      if (!target) return

      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
        10
      ) || 0
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' })
    })
  })
}
